import { Plugin } from 'rainbow-web-sdk/plugins/plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { DataChannelService_RB } from 'rainbow-web-sdk/services/dataChannel/dataChannel.service';

export class DataChannelPlugin extends Plugin {
    public static initialize(): DataChannelPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[DataChannelPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[DataChannelPlugin] initialized");
            window.rainbow.plugins[DataChannelPlugin.name] = new DataChannelPlugin();
            DataChannelService_RB.getInstance();
        }

        return window.rainbow.plugins[DataChannelPlugin.name];
    }

    private constructor() {
        super();
    }
}
